import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProDetailMeetingView のスタイル
 */
export const hotlineProDetailMeetingViewStyle = tv({
    slots: {
        content: [
            'py-24 px-16 md:p-32',
            'mb-8',
            'bg-white',
            'shadow-md',
            'md:rounded-md',
        ],
    },
    variants: {},
});
